import React from 'react';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import EntrevistasTable from '../components/EntrevistasTable';

export default function EntrevistaListPage() {
  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <EntrevistasTable />
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}
